export default "__VITE_ASSET__f01a6878__"